import React, { useState } from 'react';
import { auth, firestore } from '../firebase/firebase';
import '../assets/css/AdminLogin.css'; // Import custom styles for AdminLogin

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      // Authenticate user with Firebase Authentication
      const userCredential = await auth.signInWithEmailAndPassword(email, password);

      // If authentication is successful, retrieve user data from Firestore
      const user = userCredential.user;

      const userRef = firestore.collection('NewAdminUsers').doc(user.uid);
      const userDoc = await userRef.get();

      if (!userDoc.exists) {
        throw new Error('User data not found');
      }

      // Redirect to admin dashboard upon successful login
      // You can use React Router for navigation or handle it in App.js
      // Example: history.push('/admin/dashboard');

    } catch (error) {
      if (error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password') {
        setError('Invalid email or password. Please try again.');
      } else {
        setError('Error logging in. Please try again later.');
      }

      console.error('Error logging in:', error);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-form-container">
          <form id="login-form" onSubmit={handleLogin}>
            <h1>Welcome Back</h1>
            <p className="form-title">Lagos University Teaching Hospital Admin Portal</p>
            {error && <p className="error-message">{error}</p>}
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="login-input"
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
              required
            />
            <button type="submit" className="login-button">
              Login
            </button>
          </form>
        </div>
        <div className="illustration-container">
          <img
            src="https://mixkit.imgix.net/art/preview/mixkit-left-handed-man-sitting-at-a-table-writing-in-a-notebook-27-original-large.png?q=80&auto=format%2Ccompress&h=700"
            alt="Login Illustration"
            className="login-illustration"
          />
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
